import { API } from '@/api';
import { fetcher } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type LanesParams, lanePagedResultSchema } from '../../../models';

const pricing = fetcher.extend(() => ({ prefixUrl: `${API.BASE_PRICING}` }));

export const fetchLanes = (params: LanesParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
  const {
    carrierCorporation,
    carrierKey,
    destinationCity,
    destinationCountry,
    destinationPortKey,
    destinationPostal,
    destinationState,
    laneCode,
    laneKey,
    limit = 10,
    offset = 0,
    originCity,
    originCountry,
    originPortKey,
    originPostal,
    originState,
    providerLaneId,
  } = params;

  return pricing
    .get('lane/search', {
      searchParams: toURLSearchParams({
        CarrierCorporation: carrierCorporation,
        CarrierKey: carrierKey,
        DestinationCity: destinationCity || undefined,
        DestinationCountry: destinationCountry || undefined,
        DestinationPortKey: destinationPortKey,
        DestinationPostal: destinationPostal || undefined,
        DestinationState: destinationState || undefined,
        LaneCode: laneCode || undefined,
        LaneKey: laneKey,
        OriginCity: originCity || undefined,
        OriginCountry: originCountry || undefined,
        OriginPortKey: originPortKey,
        OriginPostal: originPostal || undefined,
        OriginState: originState || undefined,
        ProviderLaneId: providerLaneId || undefined,
        Skip: offset,
        Take: limit,
      }),
      signal,
    })
    .json(lanePagedResultSchema);
};
